//https://github.com/moroshko/autosuggest-highlight
//Wordt niet echt onderhouden meer en moest paar functies die in pullrequest stonden die er nog steeds niet in zat.
//Dan maar jatten.

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_special_characters
let specialCharsRegex = /[.*+?^${}()|[\]\\]/g;

// http://www.ecma-international.org/ecma-262/5.1/#sec-15.10.2.6
let wordCharacterRegex = /[a-z0-9_]/i;

let whitespacesRegex = /\s+/;

function escapeRegexCharacters(str) {
  return str.replace(specialCharsRegex, "\\$&");
}

export function match(text, query) {
  return (
    query
      .trim()
      .split(whitespacesRegex)
      // If query is blank, we'll get empty string here, so let's filter it out.
      .filter(function (word) {
        return word.length > 0;
      })
      .reduce(function (result, word) {
        let wordLen = word.length;
        let regex = new RegExp(escapeRegexCharacters(word), "i");
        let occurrence, index;

        occurrence = regex.exec(text);
        if (occurrence === null) {
          text = "";
          return [];
        }

        while (occurrence) {
          index = occurrence.index;
          result.push([index, index + wordLen]);

          // Replace what we just found with spaces so we don't find it again.
          text = text.slice(0, index) + new Array(wordLen + 1).join(" ") + text.slice(index + wordLen);

          occurrence = regex.exec(text);
        }

        return result;
      }, [])
      .sort(function (match1, match2) {
        return match1[0] - match2[0];
      })
  );
}

export function parse(text, matches) {
  let result = [];

  if (matches.length === 0) {
    result.push({
      text: text,
      highlight: false,
    });
  } else {
    if (matches[0][0] > 0) {
      result.push({
        text: text.slice(0, matches[0][0]),
        highlight: false,
      });
    }
  }

  matches.forEach(function (match, i) {
    let startIndex = match[0];
    let endIndex = match[1];

    result.push({
      text: text.slice(startIndex, endIndex),
      highlight: true,
    });

    if (i === matches.length - 1) {
      if (endIndex < text.length) {
        result.push({
          text: text.slice(endIndex, text.length),
          highlight: false,
        });
      }
    } else if (endIndex < matches[i + 1][0]) {
      result.push({
        text: text.slice(endIndex, matches[i + 1][0]),
        highlight: false,
      });
    }
  });

  return result;
}
